<template>
  <div class="home">
    <Layout>
      <template slot="title">
        <sm-heading size="2">Inicio</sm-heading>
      </template>
      <div class="home__row">
        <router-link to="/prospects/add">
          <sm-button
            label="+ Nueva búsqueda"
            size="medium"
            secondary
            @click="resetSteps"
          />
        </router-link>
      </div>
      <Totals></Totals>
      <div class="home__filters">
        <div v-show="isLoading" class="home__filters__loading">
          <sm-inner-loading text="Cargando..." v-model="isLoading"/>
        </div>
        <div v-show="!isLoading" class="home__filters__chart">
          <div class="home__filters__chart__title">
            <div class="home__filters__chart__title__left">INTERÉS DE USUARIOS</div>
            <div class="home__filters__chart__title__right">Usuarios contactados e interesados</div>
          </div>

          <figure class="home__filters__chart__no-lines" v-if="!isThereThisData.interested">
            <object :data="linesChartSvg" type="image/svg+xml"></object>
          </figure>
          <Line-chart
            v-if="isThereThisData.interested"
            class="home__filters__chart__content"
            :chartdata="lineChartdata"
            :options="lineOptions"
          />
        </div>

        <div v-if="!isLoading" class="home__filters__chart">
          <div class="home__filters__chart__title">
            <div class="home__filters__chart__title__left">TICKET PROMEDIO</div>
            <div class="home__filters__chart__title__right">Monto promedio crédito desembolsado</div>
          </div>
          <figure class="home__filters__chart__no-bars" v-if="!isThereThisData.meanDisbursement">
            <object :data="meanDisbursementChartSvg" type="image/svg+xml"></object>
          </figure>
          <Bar-chart
            v-if="isThereThisData.meanDisbursement"
            class="home__filters__chart__content"
            :chartdata="meanDisbursementChartData"
            :options="meanDisbursementOptions"
          />
        </div>

        <div v-if="!isLoading" class="home__filters__chart">
          <div class="home__filters__chart__title">
            <div class="home__filters__chart__title__left">CRÉDITOS DESEMBOLSADOS</div>
            <div class="home__filters__chart__title__right">Sumatoria de créditos desembolsados ($)</div>
          </div>
          <figure class="home__filters__chart__no-bars" v-if="!isThereThisData.totalDisbursement">
            <object :data="totalDisbursementChartSvg" type="image/svg+xml"></object>
          </figure>
          <Bar-chart
            v-if="isThereThisData.totalDisbursement"
            class="home__filters__chart__content"
            :chartdata="barChartdata"
            :options="barOptions"
          />
        </div>

        <div v-if="!isLoading" class="home__filters__chart">
          <div class="home__filters__chart__title">
            <div class="home__filters__chart__title__left">PROSPECTOS DESEMBOLSADOS</div>
            <div class="home__filters__chart__title__right">Número de prospectos desembolsados</div>
          </div>
          <figure class="home__filters__chart__no-bars" v-if="!isThereThisData.payed">
            <object :data="payedChartSvg" type="image/svg+xml"></object>
          </figure>
          <Bar-chart
            v-if="isThereThisData.payed"
            class="home__filters__chart__content"
            :chartdata="disbursementChartData"
            :options="disbursementOptions"
          />
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import BarChart from '@/components/charts/BarChart.js'
import LineChart from '@/components/charts/LineChart.js'

import Layout from '@/components/Layout'
import Totals from '@/components/Totals'

import linesChartSvg from '@/assets/linesChart.svg'
import meanDisbursementChartSvg from '@/assets/meanDisbursementChart.svg'
import totalDisbursementChartSvg from '@/assets/totalDisbursementChart.svg'
import payedChartSvg from '@/assets/payedChart.svg'

export default {
  name: 'Home',
  components: {
    Layout,
    Totals,
    LineChart,
    BarChart
  },
  data () {
    return {
      linesChartSvg,
      meanDisbursementChartSvg,
      totalDisbursementChartSvg,
      payedChartSvg,
      barChartdata: {
        labels: [],
        datasets: [
          {
            label: 'CRÉDITOS DESEMBOLSADOS',
            backgroundColor: '#aacc00',
            data: []
          }
        ]
      },
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            }
          }],
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return index % 2 === 0 && value > 0 ? value + 'M' : ''
              },
              beginAtZero: true
              // stepValue: 20,
              // max: 60
            },
            display: true,
            gridLines: {
              display: true,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: 'Value'
            }
          }]
        },
        legend: {
          position: 'bottom',
          align: 'center',
          display: false
        }
      },
      lineChartdata: {
        labels: [],
        datasets: [
          {
            label: 'CONTACTADOS',
            data: [],
            lineTension: 0,
            fill: false,
            borderColor: '#aacc00'
          },
          {
            label: 'INTERESADOS',
            data: [],
            lineTension: 0,
            fill: false,
            borderColor: '#00535e'
          }
        ]
      },
      lineOptions: {
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            // boxWidth: 80,
            fontColor: 'black'
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
              // stepValue: 20,
              // max: 60
            },
            display: true,
            gridLines: {
              display: true,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: 'Value'
            }
          }]
        }
      },
      meanDisbursementChartData: {
        labels: [],
        datasets: [
          {
            label: 'TICKET PROMEDIO',
            data: [],
            lineTension: 0,
            fill: false,
            type: 'line',
            borderColor: '#aacc00'
            /*
            label: 'TICKET PROMEDIO',
            backgroundColor: '#00535e',
            type: 'line',
            data: [25, 35, 20, 15, 45, 10, 50, 5],
            fill: false,
            borderCapStyle: 'square',
            spanGaps: true,
            lineTension: 0.1,
            borderColor: '#00535e', // The main line color
            borderDash: [], // try [5, 15] for instance
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'black',
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointHoverRadius: 8,
            pointHoverBackgroundColor: 'yellow',
            pointHoverBorderColor: 'brown',
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 10
            */
          }
        ]
      },
      meanDisbursementOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            }
          }],
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return index % 2 === 0 && value > 0 ? value + 'M' : ''
              },
              beginAtZero: true
              // stepValue: 20,
              // max: 60
            },
            display: true,
            gridLines: {
              display: true,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: 'Value'
            }
          }]
        },
        legend: {
          position: 'bottom',
          align: 'start',
          display: false
        }
      },
      disbursementChartData: {
        labels: [],
        datasets: [
          {
            label: 'PROSPECTOS DESEMBOLSADOS',
            backgroundColor: '#00b19d',
            type: 'bar',
            data: []
          }
        ]
      },
      disbursementOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: false,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            }
          }],
          yAxes: [{
            display: true,
            gridLines: {
              display: true,
              offsetGridLines: false,
              lineWidth: 0,
              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              labelString: 'Value'
            },
            ticks: {
              // stepValue: 20,
              // max: 60,
              beginAtZero: true,
              // stepValue: 1,
              autoSkip: false,
              callback: function (value, index, values) {
                return index % 2 === 0 && value > 0 ? value : ''
              }
            }
          }]
        },
        legend: {
          position: 'bottom',
          align: 'start',
          display: false
        }
      }
    }
  },
  watch: {
    alreadyUsers (value) {
      const alreadyUsers = value

      const users = {
        interested: alreadyUsers.filter(el => el.status === 'interested'),
        payed: alreadyUsers.filter(el => el.status === 'payed')
      }

      const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre']
      const byYear = {}

      const currentMonth = new Date().getMonth()
      const currentYear = new Date().getFullYear()

      const allowedMonthsAndYears = {}

      allowedMonthsAndYears[currentYear] = []

      if (currentMonth >= 5) {
        for (let i = 0; i < 6; i++) {
          const monthName = months[currentMonth - (5 - i)]
          allowedMonthsAndYears[currentYear].push(monthName)
        }
      } else {
        for (let i = 0; i < currentMonth + 1; i++) {
          const monthName = months[i]
          allowedMonthsAndYears[currentYear].push(monthName)
        }

        allowedMonthsAndYears[currentYear - 1] = []

        for (let i = 7 + currentMonth; i < 12; i++) {
          const monthName = months[i]
          allowedMonthsAndYears[currentYear - 1].push(monthName)
        }
      }

      users.interested.map(el => {
        const createdAt = new Date(el.createdAt)
        const year = createdAt.getFullYear()
        const month = createdAt.getMonth()
        const monthName = months[month]

        if (byYear[year]) {
          const byMonthInThisYear = byYear[year]
          if (byMonthInThisYear.interested[monthName]) {
            byMonthInThisYear.interested[monthName]++
          } else {
            byMonthInThisYear.interested[monthName] = 1
          }
        } else {
          byYear[year] = {
            interested: {},
            payed: {},
            totalDisbursement: {},
            meanDisbursement: {}
          }
          const byMonthInThisYear = byYear[year]
          byMonthInThisYear.interested[monthName] = 1
        }
      })

      users.payed.map(el => {
        const updatedAt = new Date(el.updatedAt)
        const year = updatedAt.getFullYear()
        const month = updatedAt.getMonth()
        const monthName = months[month]

        if (byYear[year]) {
          const byMonthInThisYear = byYear[year]

          if (byMonthInThisYear.payed[monthName]) {
            byMonthInThisYear.payed[monthName]++
          } else {
            byMonthInThisYear.payed[monthName] = 1
          }

          if (byMonthInThisYear.totalDisbursement[monthName]) {
            byMonthInThisYear.totalDisbursement[monthName] += el.amount
          } else {
            byMonthInThisYear.totalDisbursement[monthName] = el.amount
          }

          byMonthInThisYear.meanDisbursement = { ...byMonthInThisYear.totalDisbursement }
          const meanDisbursementKeys = Object.keys(byMonthInThisYear.meanDisbursement)
          for (const key of meanDisbursementKeys) {
            byMonthInThisYear.meanDisbursement[key] = byMonthInThisYear.meanDisbursement[key] / byMonthInThisYear.payed[key]
          }
        } else {
          byYear[year] = {
            interested: {},
            payed: {},
            totalDisbursement: {},
            meanDisbursement: {}
          }
          const byMonthInThisYear = byYear[year]

          byMonthInThisYear.payed[monthName] = 1

          byMonthInThisYear.totalDisbursement[monthName] = el.amount

          byMonthInThisYear.meanDisbursement = { ...byMonthInThisYear.totalDisbursement }
          const meanDisbursementKeys = Object.keys(byMonthInThisYear.meanDisbursement)
          for (const key of meanDisbursementKeys) {
            byMonthInThisYear.meanDisbursement[key] = byMonthInThisYear.meanDisbursement[key] / byMonthInThisYear.payed[key]
          }
        }
      })

      const final = {
        interested: {
          labels: [], data: []
        },
        payed: {
          labels: [], data: []
        },
        totalDisbursement: {
          labels: [], data: []
        },
        meanDisbursement: {
          labels: [], data: []
        }
      }

      for (const [allowedYear, allowedMonths] of Object.entries(allowedMonthsAndYears)) {
        if (byYear[allowedYear]) {
          allowedMonths.map(month => {
            final.interested.labels.push(month)
            const realInterestedValue = byYear[allowedYear].interested[month]
            final.interested.data.push(realInterestedValue || 0)

            final.payed.labels.push(month)
            const realPayedValue = byYear[allowedYear].payed[month]
            final.payed.data.push(realPayedValue || 0)

            final.totalDisbursement.labels.push(month)
            const realTotalDisbursementValue = byYear[allowedYear].totalDisbursement[month]
            final.totalDisbursement.data.push(realTotalDisbursementValue || 0)

            final.meanDisbursement.labels.push(month)
            const realMeanDisbursementValue = byYear[allowedYear].meanDisbursement[month]
            final.meanDisbursement.data.push(realMeanDisbursementValue || 0)
          })
        } else {
          allowedMonths.map(month => {
            final.interested.labels.push(month)
            final.interested.data.push(0)

            final.payed.labels.push(month)
            final.payed.data.push(0)

            final.totalDisbursement.labels.push(month)
            final.totalDisbursement.data.push(0)

            final.meanDisbursement.labels.push(month)
            final.meanDisbursement.data.push(0)
          })
        }
      }

      this.finalDashboardData(final)
      this.$store.commit('dashboardData', { data: final })
    }
  },
  computed: {
    alreadyUsers () {
      return this.$store.getters.alreadyUsers
    },
    isLoading () {
      return this.$store.getters.isLoading
    },
    dashboardData () {
      return this.$store.getters.dashboardData
    },
    isThereThisData () {
      const totalDisbursement = this.barChartdata.datasets[0].data
      const interested = this.lineChartdata.datasets[1].data
      const meanDisbursement = this.meanDisbursementChartData.datasets[0].data
      const payed = this.disbursementChartData.datasets[0].data
      return {
        totalDisbursement: totalDisbursement.length ? totalDisbursement.reduce((accum, num) => accum + num) : 0,
        interested: interested.length ? interested.reduce((accum, num) => accum + num) : 0,
        meanDisbursement: meanDisbursement.length ? meanDisbursement.reduce((accum, num) => accum + num) : 0,
        payed: payed.length ? payed.reduce((accum, num) => accum + num) : 0
      }
    }
  },
  methods: {
    resetSteps () {
      this.$store.commit('noFinalStepReset')
    },
    finalDashboardData (finalData) {
      this.barChartdata.labels = finalData.totalDisbursement.labels
      this.barChartdata.datasets[0].data = finalData.totalDisbursement.data

      this.lineChartdata.labels = finalData.interested.labels
      /**
       * @todo   TODO: implementar y llamar al servicio de contactados para la línea siguiente
       * @author Irvin Pereyra
      */
      this.lineChartdata.datasets[0].data = finalData.interested.data.map(el => 0) // Contactados por mes en 0
      this.lineChartdata.datasets[1].data = finalData.interested.data

      this.meanDisbursementChartData.labels = finalData.meanDisbursement.labels
      this.meanDisbursementChartData.datasets[0].data = finalData.meanDisbursement.data

      this.disbursementChartData.labels = finalData.meanDisbursement.labels
      this.disbursementChartData.datasets[0].data = finalData.payed.data
    }
  },
  created () {
    if (this.dashboardData) {
      this.finalDashboardData(this.dashboardData)
    }
  }
}
</script>

<style>
.home__filters__loading {
  align-items: center;
  display: flex;
  height: calc(100% - 400px);
  justify-content: center;
  max-width: 924px;
  position: absolute;
  top: 350px;
  width: 100%;
  z-index: 9;
}

.home__row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.home__row__button {
  color: white;
  font-size: 14.5px;

  background: #00535e;
  border-color: #00535e;
  border-radius: 7px;
  border-style: solid;
  border-width: 2px;
  cursor: pointer;
  float: right;
  padding: 10px 0;
  position: relative;
  width: 160px;
}

.home__filters {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 1fr 1fr;
  grid-gap: 10px;
  height: 100%;
  justify-content: space-between;
  width: calc(100% - 10px);
}

.home__filters__chart {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
}

.home__filters__chart--no-data {
  background: #FFFFFF;
  border: 1px solid #F7F7F7;
  box-sizing: border-box;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);
  border-radius: 7px;
  margin: 100px 0;
  padding: 20px 50px;
  width: calc(100% - 150px);
}

.home__filters__chart__title {
  align-items: center;
  border-color: #bcbcbc;
  border-style: solid;
  border-width: 0 0 1px 0;
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: left;
  margin-bottom: 5px;
  width: 100%;
}

.home__filters__chart__title__left {
  color: #00535e;
  font-size: 11px;
  font-weight: bold;

  padding: 15px;
  text-align: left;
}

.home__filters__chart__title__right {
  color: #535353;
  font-size: 10px;

  width: calc(100% - 200px);
}

.home__filters__chart__content {
  padding: 30px;
  height: 450px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
